import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Button,
  Box,
  Group,
  Image,
  Center,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import { IconPhoto } from '@tabler/icons-react';

import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ImageUploadWithPreview from '../../Utilities/ImageUploadWithPreview';

function AddBanner() {
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImagePath, setExistingImagePath] = useState(null);

  const form = useForm({
    initialValues: {
      id: '',
      name: '',
      primarytext: '',
      secondarytext: '',
      compcode: user?.compcode || '',
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.Banner_GetById}/${id}/${user.compcode}`
        )
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            const amenity = response.data.data[0];
            form.setValues({
              id: amenity.id,
              compcode: amenity.compcode,
              name: amenity.name,
              primarytext: amenity.primarytext,
              secondarytext: amenity.secondarytext,
            });

            if (amenity.bannerimage) {
              setExistingImagePath(`${process.env.REACT_APP_IMG_URL}/${amenity.bannerimage}`);
            }
          }
        })
        .catch((err) => {
          console.error('Error loading amenity:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [id, user.compcode]);

  const handleSubmit = (values) => {
    // Validation
    // if (!values.amenitiesname.trim()) {
    //   toast.error('Amenity name is required.');
    //   return;
    // }

    // if (!id && !selectedFile) {
    //   toast.error('Image is required for new amenity.');
    //   return;
    // }


    setLoading(true);

    const formData = new FormData();
    formData.append('id', id || 0);
    formData.append('name', values.name);
    formData.append('primarytext', values.primarytext);
    formData.append('secondarytext', values.secondarytext);
    formData.append('compcode', user?.compcode || '');
    if (selectedFile) {
      formData.append('bannerimage', selectedFile);
    }

    const request = id && id !== 0
      ? axios.put(`${process.env.REACT_APP_API_URL}/${ApiLinks.Banner_Update}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      : axios.post(`${process.env.REACT_APP_API_URL}/${ApiLinks.Banner_Update}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    request.then((res) => {
      if (res.data.status) {
        Swal.fire({
          title: id ? 'Updated!' : 'Created!',
          text: `Banner ${id ? 'updated' : 'created'} successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/dashboard/banner');
        });
      } else {
        Swal.fire('Error!', res.data.message || 'Failed to save amenity.', 'error');
      }
    })
      .catch(() => {
        Swal.fire('Error!', 'An error occurred while saving.', 'error');
      })
      .finally(() => setLoading(false));

  };



  if (loading) return <LoaderOverlay />;

  return (
    <Box maw={500} mx="auto" sx={(theme) => ({
      backgroundColor: 'white',
      padding: theme.spacing.xl,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadows.md,
    })}>
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit Banner' : 'Create Banner'}</h2>
        <Button onClick={() => navigate('/dashboard/banner')}>Back</Button>
      </Group>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          label="PrimaryText"
          placeholder="Enter name"
          {...form.getInputProps('primarytext')}

        />

        <TextInput
          label="Secondry"
          placeholder="Enter name"
          {...form.getInputProps('secondarytext')}

        />

        <ImageUploadWithPreview
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          existingImagePath={existingImagePath}
          setExistingImagePath={setExistingImagePath}
          label="Upload Main Image (16:9 preview)"
          fullWidthPreview={true}
        />



        <Button type="submit" mt="lg" fullWidth>
          {id ? 'Update' : 'Create'}
        </Button>
      </form>
    </Box>
  );
}

export default AddBanner;
